import { SurveySatisfactionScore } from 'modules/survey/management/interfaces';

export const gpScore = ({
  total = 0,
  veryUnsatisfiedTotal = 0,
  satisfiedTotal = 0,
  neutralTotal = 0,
  unsatisfiedTotal = 0,
  verySatisfiedTotal = 0,
}: SurveySatisfactionScore) => {
  if (!total) return 0;

  const index =
    (verySatisfiedTotal * 5 + satisfiedTotal * 4 + neutralTotal * 3 + unsatisfiedTotal * 2 + veryUnsatisfiedTotal) /
    total;

  return (index / 5) * 100;
};

export const satisfactionScore = (positivesTotal: number, totalAnswers: number) => {
  if (!totalAnswers) return 0;

  return (positivesTotal / totalAnswers) * 100;
};

export const npsScore = (promotersTotal: number, detractorsTotal: number, totalAnswers: number) => {
  if (!totalAnswers) return 0;

  const promoterPercent = (promotersTotal / totalAnswers) * 100;
  const detractorPercent = (detractorsTotal / totalAnswers) * 100;

  return promoterPercent - detractorPercent;
};
